/**
 *  @license
 *    Copyright 2018 Brigham Young University
 *
 *    Licensed under the Apache License, Version 2.0 (the "License");
 *    you may not use this file except in compliance with the License.
 *    You may obtain a copy of the License at
 *
 *        http://www.apache.org/licenses/LICENSE-2.0
 *
 *    Unless required by applicable law or agreed to in writing, software
 *    distributed under the License is distributed on an "AS IS" BASIS,
 *    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *    See the License for the specific language governing permissions and
 *    limitations under the License.
 **/
'use strict'

const config = {
  // site default settings
  site: {

    // default site navigation links
    navigationLinks: [
      { href: '/', title: 'Home' },
      { href: '/person-memberships', title: 'Person Memberships' },
      { href: '/group-members', title: 'Group Members' },
      { href: '/administrators/person-view', title: 'Administrators' },
      { href: '/groups-i-administer', title: 'Groups I Administer' },
      { href: '/group-maintenance', title: 'Group Maintenance' }
    ],

    // default site title (in title bar)
    pageTitle: { pre: '', main: 'Group Information', post: '' },

    // how many milliseconds to wait before performing an automatic search - set to zero (0) to disable
    searchDebounce: 350,

    // default search functionality - set to null to disable
    searchHandler: null,

    // default browser page title (modification requires rebuild)
    title: 'BYU | Group Information'
  }
}

module.exports = config
